import { Option } from '../../general-types';
import { ValueOfKey } from '../../utils-types';

export const SCORING_RULE = {
  FAT_LOSS_MUSCLE_GAIN_FOOD_TRACKING: 'FAT_LOSS_MUSCLE_GAIN_FOOD_TRACKING',
  FAT_LOSS_MUSCLE_GAIN: 'FAT_LOSS_MUSCLE_GAIN',
  FAT_LOSS: 'FAT_LOSS',
} as const;

export type ScoringRuleType = ValueOfKey<typeof SCORING_RULE>;

export const humanizedScoringRule: Record<ScoringRuleType, string> = {
  [SCORING_RULE.FAT_LOSS_MUSCLE_GAIN_FOOD_TRACKING]:
    'Fat Loss, Muscle Gain, Food Tracking',
  [SCORING_RULE.FAT_LOSS_MUSCLE_GAIN]: 'Fat Loss, Muscle Gain (Recomposition)',
  [SCORING_RULE.FAT_LOSS]: 'Fat Loss',
};

export const scoringRuleOptions: Option<ScoringRuleType>[] = [
  {
    value: SCORING_RULE.FAT_LOSS_MUSCLE_GAIN_FOOD_TRACKING,
    label: humanizedScoringRule[SCORING_RULE.FAT_LOSS_MUSCLE_GAIN_FOOD_TRACKING],
  },
  {
    value: SCORING_RULE.FAT_LOSS_MUSCLE_GAIN,
    label: humanizedScoringRule[SCORING_RULE.FAT_LOSS_MUSCLE_GAIN],
  },
  { value: SCORING_RULE.FAT_LOSS, label: humanizedScoringRule[SCORING_RULE.FAT_LOSS] },
];
